<template>
  <container>
    <h1 style="font-size: 25px;margin-bottom: 20px;text-align: center;margin-top: 10px;">Feedback</h1>
    <div style="margin-bottom:50px">
      <div style="float: left;width: 25%;">
        <img class="calImg" src="../../../assets/calender2.png" alt="LiveRun">
        <div  class="month-year-select ">   
          <vue-monthly-picker
            v-model="selectedMonth"
            :selectedBackgroundColor="selectedBackgroundColor"
            :monthLabels="locale"
            :dateFormat='dateFormat'
            @selected="handleSelect"
            placeHolder='All Time'
          >
          </vue-monthly-picker>        
        </div>
      </div>
      <div>
        <select v-model="trainerId" label="Trainer" name="Trainer"  @change="changeHandle" class="trainer-list">
              <option value="All" selected>All</option>
            <option v-for="(trainer, index) in trainerList" v-bind:value="trainer.id" :key="index">{{trainer.firstName}}</option>
          </select>
      </div>    
    </div>
    <div class="feedback-table">      
      <v-table
        :is-loading="loading"
        is-horizontal-resize
        style="width:100%;font-size:11px"
        :columns="columns"        
        :table-data="tableData"       
        :title-row-height ="30"
        :row-height="70"
        :border="1"     
        :column-cell-class-name="columnCellClass"
      ></v-table>

      <div class="mt20 mb20 bold" style="padding-top:25px">
        <v-pagination @page-change="pageChange" @page-size-change="pageSizeChange" :total="pageTotal" :pageIndex ="pageIndex+1" :page-size="pageSize" :layout="['total', 'prev', 'pager', 'next', 'sizer', 'jumper']"></v-pagination>
      </div>
    </div>

  </container>
</template>
<script>
import Container from "@/components/Container"
import { mapActions, mapGetters } from "vuex"
import {VTable,VPagination} from 'vue-easytable'
import DateRangeField from '@/components/Forms/DateRangeField'
import FeedbackService from "@/services/feedback"
import TrainerService from '@/services/trainer'
import VueMonthlyPicker from 'vue-monthly-picker'
import {sortBy,prop} from 'ramda'
import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'
export default {
  name: "feedback",
  data() {
    return {      
      columns: [
        {field: "raceDate", title:'Date', width: 100, titleAlign: 'center',columnAlign:'center',
          componentName:'separate-date-time',
        },
        {field: "raceTime", title:'Run Start', width: 100, titleAlign: 'center',columnAlign:'center',
          componentName:'separate-date-time',
        },              
        
        {field: "runName", title:'Session', width: 250, titleAlign: 'center',columnAlign:'center',
          formatter: function (rowData,rowIndex,pagingIndex,field) {
            return '<a class="race_name" href="#/admin/past-run/detail/'+rowData.raceId+'" target="_blank"><div>'+rowData.runName+'</div></a>'
            }
        },
        {field: "trainerName", title:'Trainer', width: 120, titleAlign: 'center',columnAlign:'center'},
        {field: "runnerName", title:'Runner', width: 100, titleAlign: 'center',columnAlign:'center',componentName:'runner-page' },
        // {field: "text", title:'Feedback', width: 508, titleAlign: 'center',columnAlign:'center',
        // },
        
        // {field: "text", title:'Feedback',  width: 4400, titleAlign: 'left',columnAlign:'left',isResize:true, } 
       
      //  {field: "text", title:'Feedback',  width: 530, titleAlign: 'left',columnAlign:'left',isResize:true, 
      //     formatter: function (rowData,rowIndex,pagingIndex,field) {
      //       return '<div style = "width:100%;">'+rowData.text+'</div>'
      //       // return '<div style = "width:508;overflow-y:auto">'+rowData.text+'</div>'
      //     }
      //   }, 
      {field: "text", title:'Feedback', width: 525, titleAlign: 'center',columnAlign:'center' ,isResize:true},

      ],
      tableData :[],
      pageIndex:0,
      pageTotal:null,
      pageSize:10,       
      // rangeData:{
      //   startDate: moment().startOf('month').startOf('day').toISOString(),
      //   endDate:  moment().endOf('month').endOf('day').toISOString(),
      // },
      locale: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],  
      dateFormat:"MMMM , YYYY",
      selectedMonth: moment(),
      selectedBackgroundColor: '#423799', 
      startDate:moment().startOf('month').toISOString(),
      endDate:moment().endOf('month').toISOString(),
      loading:false,
      trainerList:[],
      trainerId:'All',
    }
  },
  computed: {
  },
  methods: {
    columnCellClass(rowIndex,columnName,rowData){
      if (columnName==='text'){
        return 'column-cell-class-name-text'
      }
    },
    intialize(){      
      TrainerService.getAll().then(response => {
        if(response.data && response.data != undefined && response.data != ''){
          this.trainerList = response.data
          //this.trainerList = sortBy(prop('firstName'),response.data)
        }
      }).catch(error => {
        console.log("err--->>",error)
      })
      this.getFeedback(this.startDate,this.endDate,this.trainerId,this.pageIndex,this.pageSize)   
    },
    getFeedback(startDate,endDate,trainerId,pageIndex,pageSize){
      this.loading=true
      FeedbackService.getFeedback(startDate,endDate,trainerId,pageIndex,pageSize).then(response => {
        this.tableData=response.data.content
        this.pageTotal = response.data.totalElements
        this.loading=false
      }).catch(error => {
        this.loading=false
        console.log("err--->>",error)
      })
    },
    pageChange(pageIndex){
      this.pageIndex = pageIndex-1
      this.getFeedback(this.startDate ,this.endDate,this.trainerId,this.pageIndex,this.pageSize)        
    },
     pageSizeChange(pageSize){
      this.pageIndex = 0
      this.pageSize = pageSize
      this.getFeedback(this.startDate,this.endDate,this.trainerId,this.pageIndex, this.pageSize)        
    },  
    handleSelect (value) {
      this.pageIndex = 0
      if(value!=null){       
        var monthYear = moment([value.year(), value.month()])
        this.startDate= moment(monthYear).startOf('month').toISOString()
        this.endDate =  moment(monthYear).endOf('month').toISOString()  
      }else{        
        this.startDate= ''
        this.endDate =  ''
      }
      this.getFeedback(this.startDate,this.endDate,this.trainerId,this.pageIndex, this.pageSize)      
    },
    changeHandle(){
       this.pageIndex = 0
      //console.log("selectedTrainer--->",this.trainerId)
      this.getFeedback(this.startDate,this.endDate,this.trainerId,this.pageIndex, this.pageSize)   
    }
  },
  created() {
    this.intialize()
  },
  watch: {
    // rangeData(oldVal, newVal) {
    //   this.pageIndex = 0
    //   this.pageSize= 10
    //   this.intialize()
    // }
  },
  components: {
    Container,
    DateRangeField,
    VueMonthlyPicker
  }
}


Vue.component('separate-date-time',{
  template:` <div>
                <span v-if="field == 'raceDate'">{{newdate}}</span>
                <span  v-if="field == 'raceTime'">{{newTime}}</span>
              </div>
            `,
  mounted () {
    //this.initdata()
  },
  data: () => ({
    newdate: '',
    newTime:''
  }),
  props:{
    rowData:{
        type:Object
    },
    field:{
        type:String
    },
    index:{
        type:Number
    }      
  },
  methods:{
    initdata(){
      var utcDate = this.rowData.runDateTime
      this.newdate= moment(utcDate).format('YYYY-MM-DD')
      this.newTime= moment(utcDate).format('HH:mm:ss')
    },           
  },
  created () {
    this.initdata()
  },
  watch: {
      rowData: function (val) {
      this.initdata()
    },
  }
})

Vue.component('runner-page',{
        template:`<span>
        <a href="" @click.stop.prevent="runnerData()">{{rowData.runnerName}}</a>&nbsp
        </span>`,
        data: () => ({
        //   id:null 
        }),
        props:{
            rowData:{
                type:Object
            },
            field:{
                type:String
            },
            index:{
                type:Number
            }
        },
        methods:{
          runnerData(){
              let route = this.$router.resolve({
                    name: 'runner-data',
                    params: {
                          runnerId: this.rowData.runnerId
                        }
                    })
              window.open(route.href, '_blank')
          }
        },
        created() { 
        }
})
</script>

<style>
.feedback-table tr.v-table-header-row {
    background: #423799;
    color: white;
    font-size: 12px;
    font-weight: bold;
}

/* .feedback-table tr.v-table-row {
    cursor: pointer;
} */

.footer-cell-class-name-title {
  background-color: #f60;
  color: #fff;
  font-size: 14px;
}
.footer-cell-class-name-normal {
    color: red;
    font-size: 14px;
}
.trainer-list{
  background: transparent;
  height: 29px;
  border-radius: 5px;
  min-width: 125px;
}
.feedback-table .v-table-body-cell.vertical-border.horizontal-border{
  height :70px!important;
  line-height: 70px!important; 
}
.feedback-table .column-cell-class-name-text .v-table-body-cell.vertical-border.horizontal-border{
  line-height: initial!important;
   text-align: left!important;
}
.feedback-table .v-table-body-cell{
  white-space: initial!important
}
</style>



// WEBPACK FOOTER //
// Feedback.vue?35092e50